import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Organization",
    href: (params) => `/admin/batch-registration/1`,
  },
  {
    label: "Upload Students",
    href: (params) => `/admin/batch-registration/2`,
  },
  {
    label: "Schedule Tests",
    href: (params) => `/admin/batch-registration/3`,
  },
]

export const BatchRegistrationStepper = () => {
  return <Stepper steps={steps} />
}
